import {
	AttemptId,
	ItemId, ProductId,
	QuizId, Serializer
} from "../../model/datasource";
import { FlashHeaderFrontend, HeaderFrontend, PqHeaderFrontend } from "./header";
import { FlashItemFrontend, ItemFrontend, PqItemFrontend } from "./item";
import { ListFrontend } from "./list";
import { ScoreFrontend } from "./score";
import { SectionFrontend } from "./section";
import { SettingsFrontend } from "./settings";
import { SummaryFrontend } from "./summary";
import { ChartFrontend } from "./chart";

export abstract class FrontendFactory<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> {
	abstract headerFrontend(item: Serializer<I>): HeaderFrontend<I>;
	abstract listFrontend(item: Serializer<I>): ListFrontend<I>;
	abstract itemFrontend(item: Serializer<I>): ItemFrontend<I>;
	abstract scoreFrontend(): ScoreFrontend;
	abstract sectionFrontend(quiz: Serializer<Z>, item: Serializer<I>): SectionFrontend<Z, I>;
	abstract settingsFrontend(item: Serializer<I>): SettingsFrontend<I>;
	abstract summaryFrontend(product: Serializer<P>): SummaryFrontend<P>;
	abstract chartFrontend(product: Serializer<P>): ChartFrontend<P, A, Z>;
}

export abstract class PqFrontendFactory<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends FrontendFactory<P, A, Z, I> {
	abstract headerFrontend(item: Serializer<I>): PqHeaderFrontend<I>;
	abstract itemFrontend(item: Serializer<I>): PqItemFrontend<I>;
}

export abstract class FlashFrontendFactory<P extends ProductId, A extends AttemptId, Z extends QuizId, I extends ItemId> extends FrontendFactory<P, A, Z, I> {
	abstract headerFrontend(item: Serializer<I>): FlashHeaderFrontend<I>;
	abstract itemFrontend(item: Serializer<I>): FlashItemFrontend<I>;
}

export {
	HeaderFrontend, ListFrontend, ItemFrontend, ScoreFrontend, SectionFrontend,
	SettingsFrontend, SummaryFrontend, PqItemFrontend, PqHeaderFrontend,
	FlashHeaderFrontend, FlashItemFrontend, ChartFrontend
};